// useStateを追加。
import React, {useState, useEffect} from 'react'
import FullCalendar from '@fullcalendar/react'
import timeGridPlugin from '@fullcalendar/timegrid'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list'
import interactionPlugin from '@fullcalendar/interaction'
import jaLocale from '@fullcalendar/core/locales/ja';
import { styled } from '@mui/system';
import { Typography, Box, Button } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import dayjs from "dayjs";
import 'dayjs/locale/ja'

// コンテナスタイル
const Container = styled('div')({
  padding: '30px',
  width: '100%',
  height: 'auto'
});

// 追加するイベントの型。
export interface EventsType {
  id: number
  title: string
  start: string
  end: string
}

// プロパティ
type Props = {
  events: EventsType[],
}

// カレンダー
const EventCalendar: React.FC<Props> = (props) => {
  /**
   * 予定を追加する際にCalendarオブジェクトのメソッドを使用する必要がある。
   * (CalendarオブジェクトはRef経由でアクセスする必要がある。)
   */
  const ref = React.createRef<any>()

  // 登録されたイベントが格納されていく。EventsTypeタイプの配列。
  const [events, setEvents] = useState<EventsType[]>([])
  const [showTitle, setShowTitle] = useState<string>("")
  const [showDate, setShowDate] = useState<string>("")
  const [showTime, setShowTime] = useState<string>("")
  const [openDialog, setOpenDialog] = useState<boolean>(false)

  // イベントクリック
  const handleEventCLick = (info: any) => {
    // タイトル設定
    setShowTitle(info.event.title)
    // 日付フォーマット
    let dateStr = dayjs(info.event.startStr).format('YYYY年M月D日(ddd)')
    // 日付設定
    setShowDate(dateStr)
    // 開始時刻フォーマット
    let timeStr = ""
    if (info.event.startStr.length > 12) {
      timeStr = dayjs(info.event.startStr).format('H:mm')
    }
    // 終了時刻フォーマット
    if (info.event.endStr.length > 12) {
      if (timeStr == "") timeStr += "0:00"
      timeStr += "～" + dayjs(info.event.endStr).format('H:mm')
    }
    // 時刻設定
    setShowTime(timeStr)
    // ダイアログ表示
    setOpenDialog(true)
  }
  // ダイアログ閉じるボタン
  const handleDialogClose = () => {
    // ダイアログ非表示
    setOpenDialog(false);
  };

  useEffect(() => {
    // イベントリスト設定
    setEvents(props.events)

    // イベントクリア
    ref.current.getApi().removeAllEvents()
    // イベントをカレンダーに追加
    for (const event of props.events) {
      // カレンダーに予定を登録して表示するための処理。
      ref.current.getApi().addEvent(event)
    }
  }, [props.events])

  // プロパティ
  const PropertyDialog = (
    <>
      <Dialog open={openDialog} onClose={handleDialogClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">
          <Box mb={2}>
            <Typography align="center" variant="inherit">取材の予定</Typography>
          </Box>
          <Typography variant="h5" sx={{ fontWeight: 'bold' }}>{showTitle}</Typography>
        </DialogTitle>
        <DialogContent sx={{pr:20}}>
          <DialogContentText id="alert-dialog-description">
            <Typography variant="inherit">{showDate}</Typography>
            <Typography variant="inherit">{showTime}</Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{p:2}}>
          <Button onClick={handleDialogClose} variant="contained" style={{color: 'white', backgroundColor: 'black'}} autoFocus>閉じる</Button>
        </DialogActions>
      </Dialog>        
    </>
  )

  // カレンダーレンダリング
  return (
    <Container>
      {PropertyDialog}
      <FullCalendar
        height="auto"
        //height="100vh"
        locale="ja"
        locales={[jaLocale]}
        plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]}
        initialView="dayGridMonth"  //or timeGridWeek
        slotDuration="00:30:00"
        selectable={true}
        dayMaxEvents={true}   // イベント表示しきれない時にポップアップ heightがautoだと表示されない
        businessHours={{
          daysOfWeek: [1, 2, 3, 4, 5],
          startTime: '00:00',
          endTIme: '24:00'
        }}
        weekends={true}
        titleFormat={{
          year: 'numeric',
          month: 'short'
        }}
        headerToolbar={{
          start: 'title',
          center: 'prev, next, today',
          end: 'dayGridMonth, timeGridWeek, listWeek'
        }}
        ref={ref}
        eventClick={handleEventCLick}
        //追加はできないようにする
        //select={handleSelect}
      />
    </Container>
  )
}

export default EventCalendar